/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'message-items';
const componentName = 'content-rewrite-rule';
const prefix = `${moduleName}.${componentName}`;

export const requestContentRewriteRuleBreadCrumbTitle = `${prefix}.requestContentRewriteRuleBreadCrumbTitle`;

export const ENGLISH = {
    [requestContentRewriteRuleBreadCrumbTitle]: 'Request Content Rewrite Rule',
};
